<script lang="ts">
  import { clamp } from "@/libs/math"
  import type { HTMLOlAttributes } from "svelte/elements"

  let {
    count = 0,
    active = $bindable(0),
    ...props
  }: { count?: number; active?: number } & HTMLOlAttributes = $props()

  $effect(() => {
    const clamped = clamp(active, { min: 0, max: count - 1 })

    if (active !== clamped) active = clamped
  })
</script>

<ol {...props} class={["flex gap-0.5", props.class]}>
  {#each new Array(count) as _, idx}
    <li class="flex">
      <input
        class={[
          "size-2.5 cursor-pointer appearance-none p-0.5",
          "after:flex after:size-full after:rounded-full after:bg-white after:bg-opacity-60 after:transition-colors",
          "checked:after:bg-opacity-100",
        ]}
        type="radio"
        name="index"
        value={idx}
        bind:group={active}
      />
    </li>
  {/each}
</ol>
